/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React,{useState,useRef} from 'react'
import 'react-calendar/dist/Calendar.css';
import { useOnClickOutside } from '../../CommonMethods/OutsideClick';
import YearPicker from './YearPicker';
import MonthPicker from './MonthPicker';

export default function CustomMonthYearPicker({DateRange,start,end,DateRangeError,customKey,datePickeropen,setDatePickeropen,isFilter, onYearClick, onMonthClick, selectedYear, selectedMonth }) {
    const [open, setopen] = useState('');
    const ref =useRef(null)

    const [showYear, setShowYear] = useState(false);

    useOnClickOutside(ref,()=>{
        setopen('');
    })

    const changeHandler = () => {
        setShowYear(prevState => !prevState);
    }

    return (
        <div className={`relative z-10`}>
            <div ref={ref}>
                {!showYear && <MonthPicker onMonthClick={onMonthClick} selectedYear={selectedYear} onChange={changeHandler} selectedMonth={selectedMonth} />}
                {showYear && <YearPicker onYearClick={onYearClick} onChange={changeHandler} selectedYear={selectedYear} isMonthYearPicker={true} />}
            </div>
        </div>
    )
}
